// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { DocumentFolder } from "../../types";

const documentFoldersModule = {
  async findByMatterId(matterId: string, userId: string): Promise<DocumentFolder[]> {
    const result = await sql`
      SELECT * FROM document_folders
      WHERE matter_id = ${matterId} AND user_id = ${userId}
      ORDER BY position ASC, created_at ASC
    `;
    return (result || []) as DocumentFolder[];
  },

  async findByProjectId(projectId: string, userId: string): Promise<DocumentFolder[]> {
    const result = await sql`
      SELECT * FROM document_folders
      WHERE project_id = ${projectId} AND user_id = ${userId}
      ORDER BY position ASC, created_at ASC
    `;
    return (result || []) as DocumentFolder[];
  },

  async create(data: Omit<DocumentFolder, 'id' | 'created_at' | 'updated_at'>): Promise<DocumentFolder> {
    const result = await sql`
      INSERT INTO document_folders (
        user_id, name, matter_id, project_id, parent_folder_id, position
      )
      VALUES (
        ${data.user_id}, ${data.name}, ${data.matter_id}, ${data.project_id}, 
        ${data.parent_folder_id}, ${data.position}
      )
      RETURNING *
    `;
    return result[0] as DocumentFolder;
  },

  async update(id: string, userId: string, data: Partial<DocumentFolder>): Promise<DocumentFolder> {
    const result = await sql`
      UPDATE document_folders
      SET 
        name = CASE WHEN ${data.name === undefined} THEN name ELSE ${data.name} END,
        position = CASE WHEN ${data.position === undefined} THEN position ELSE ${data.position} END,
        updated_at = NOW()
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as DocumentFolder;
  },

  async delete(id: string, userId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM document_folders
      WHERE id = ${id} AND user_id = ${userId}
    `;
    return result.count === 1;
  }
};

export type DocumentFoldersModule = typeof documentFoldersModule;

export function registerDocumentFolders(db: { documentFolders?: DocumentFoldersModule }) {
  db.documentFolders = documentFoldersModule;
}

export { documentFoldersModule as documentFolders };
